export { default } from './fitment-title';
